import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import toastify CSS
import ResetPasswordModal from "../Components/ResetPassword";
import "../Components/CSS/Global.css";

const LoginModal = ({ isOpen, onClose, onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [isExistingCustomer, setIsExistingCustomer] = useState(null);
  const [password, setPassword] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [error, setError] = useState(false);
  const [resetPasswordOpen, setResetPasswordOpen] = useState(false);

  const showToast = (message, type = "info") => {
    toast(message, {
      type,
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const handleContinue = async () => {
    try {
      const response = await axios.post("http://localhost:5000/check-user", {
        email,
      });

      if (response.data.exists) {
        setIsExistingCustomer(true);
      } else {
        setIsExistingCustomer(false);
        await axios.post("http://localhost:5000/send-otp", { email });
        showToast("Check your email for the verification code.", "success");
      }
    } catch (error) {
      console.error("Error checking user or sending OTP:", error);
      showToast("Error checking user or sending OTP", "error");
    }
  };

  const handleSignIn = async () => {
    try {
      const response = await axios.post("http://localhost:5000/check-login", {
        email,
        password,
      });

      if (response.status === 200) {
        showToast("Login successful.", "success");
        setError(false);
        onLoginSuccess(email);
        onClose();
      } else {
        setError(true);
        showToast("Invalid email or password.", "error");
      }
    } catch (error) {
      console.error("Login failed", error);
      setError(true);
      showToast("Invalid email or password.", "error");
    }
  };

  const handleSignUp = async () => {
    if (!verificationCode) {
      setError(true);
      showToast("Enter the OTP sent to your email", "warning");
      return;
    }

    try {
      const response = await axios.post("http://localhost:5000/verify-otp", {
        email,
        otp: verificationCode,
        password: password,
      });

      if (response.status === 200) {
        showToast("OTP verified successfully. Proceeding with sign-up.", "success");
        setError(false);
        onLoginSuccess(email);
        onClose();
      }
    } catch (error) {
      console.error("OTP verification failed", error);
      setError(true);
      showToast("Failed to verify OTP.", "error");
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close" onClick={onClose}>
            <i className="fa-solid fa-xmark"></i>
          </button>

          {isExistingCustomer === null && (
            <div className="email-check">
              <div className="input-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <button className="Modal-continue" onClick={handleContinue}>
                Continue
              </button>
              {error && <p className="red">Enter Valid Email ID</p>}
              <div className="divider">Or</div>
              <button className="google">Sign in With Google</button>
              <p className="reset-password-link">
                Forgot Password?{" "}
                <p
                  onClick={() => setResetPasswordOpen(true)}
                  className="reset-password-btn"
                >
                  Reset Password
                </p>
              </p>
            </div>
          )}

          {/* Existing Customer Sign In */}
          {isExistingCustomer === true && (
            <div className="existing-customer">
              <div className="input-group">
                <label htmlFor="email">Email</label>
                <input type="email" name="email" id="email" value={email} readOnly />
              </div>
              <div className="input-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <button className="sign" onClick={handleSignIn}>
                Sign In
              </button>
            </div>
          )}

          {/* New Customer Sign Up */}
          {isExistingCustomer === false && (
            <div className="new-customer">
              <div className="input-group">
                <label htmlFor="email">Email</label>
                <input type="email" name="email" id="email" value={email} readOnly />
              </div>
              <div className="input-group verification">
                <label htmlFor="number">Verification Code</label>
                <input
                  type="number"
                  name="number"
                  id="number"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                />
                {error && <p className="red">Enter the OTP sent to your email</p>}
              </div>
              <div className="input-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <button className="sign" onClick={handleSignUp}>
                Sign Up
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Reset Password Modal */}
      {resetPasswordOpen && (
        <ResetPasswordModal
          isOpen={resetPasswordOpen}
          onClose={() => setResetPasswordOpen(false)}
        />
      )}

    </>
  );
};

export default LoginModal;
